import React, { useEffect } from 'react';
import Layout from '../../shared/components/Layout';
import Complete from '@/components/Complete';
import clearLocalStorage from '@/utils/clearLocalStorage';

const RegistrationComplete: React.FC = () => {
  useEffect(() => {
    clearLocalStorage();
  }, [])
  return (
    <React.Fragment>
      <Layout>
        <Complete id="page-facility_login" heading="新規契約完了" content="新規契約が完了しました。"isFacility={false}  />
      </Layout>
    </React.Fragment>
  )
}

export default RegistrationComplete;